import { render, staticRenderFns } from "./LogsManutencao.vue?vue&type=template&id=36e5d2fa&"
import script from "./LogsManutencao.vue?vue&type=script&lang=js&"
export * from "./LogsManutencao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports